export default __webpack_public_path__ + "content/media/24.4501a1a4.jpg";